/*
 * @Author: Kuaiyin FE
 * @Date: 2020-07-08 17:47:37
 * @Description: 桥接方法
 * @FilePath: /kuaiyin-h5/src/sdk/index.js
 */
// import device from '@/utils/device';
import platform from '../lib/platform';
import { androidSdkInit, androidRegister, androidAppCall } from './android_sdk';
import { iosRegister, iosAppCall } from './ios_sdk';

class SDK {
	constructor() {
		// 平台类型
		this.platfrom = '';

		// bridge注册事件方法
		this.register = null;
		// js调用bridge方法
		this.appCall = null;

		// sdk初始化
		this.init();
	}

	/**
	 * @description: 初始化方法
	 * @return: void
	 */

	init() {
		this.platfrom = platform.platform; // device.getDevicePlatform();

		if (this.platfrom === 'android') {
			// 'Android'
			androidSdkInit();
			this.register = androidRegister;
			this.appCall = androidAppCall;
		} else if (this.platfrom === 'ios') {
			// 'IOS'
			this.register = iosRegister;
			this.appCall = iosAppCall;
		} else {
			console.log(`开发模式，默认使用 Android 初始化方法！`);
			androidSdkInit();
			this.register = androidRegister;
			this.appCall = androidAppCall;
		}
	}
}
const sdk = new SDK();

export default sdk;



// WEBPACK FOOTER //
// ./src/sdk/index.js